import store from '../store/index'
import routes from './routes'

const role = store.getters['auth/loggedInUser'].role

function filterRoutesByRole () {
  return routes.filter(item => {
    const roles = item?.meta?.roles

    if (Array.isArray(roles)) {
      return item.meta.roles.includes(role)
    }

    return true
  })
}

export default filterRoutesByRole()
